import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-finding-report.controller';
import directive from './attach-finding-report.directive';


export default angular.module('app.components.advisory.auditTrail.attachFindingReport', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachFindingReport', directive)
  .controller('AttachFindingReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachFindingReport created');
